import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Injector, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DsDatepickerConfiguration } from '@bmw-ds/components';
import { ValueAccessor } from '../../value-accessor/value-accessor';

@Component({
    selector: 'density-datepicker',
    templateUrl: './density-datepicker.component.html',
    styleUrl: './density-datepicker.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DensityDatepickerComponent),
            multi: true
        }
    ],
    standalone: false
})
export class DensityDatepickerComponent extends ValueAccessor<Date> {
    @Input()
    inputId: string = '';

    @Input()
    label: string = '';

    @Input()
    isDisabled: boolean = false;

    @Input()
    showOptionalLabel: boolean = false;

    @Input()
    placeholder: string = '';

    @Input()
    styleClass: string = '';

    @Output()
    valueChanged = new EventEmitter<Date>();

    @Input()
    set config(value: Partial<DsDatepickerConfiguration>) {
        this._config = { ...this.defaultConfig, ...value };
    }

    constructor(injector: Injector) {
        super(injector);
    }

    defaultConfig: Partial<DsDatepickerConfiguration> = {
        selectionMode: 'single',
        allowDirectInput: false,
        showClearAll: false,
        isReadOnly: true,
        showButtonBar: false
    };

    private _config: Partial<DsDatepickerConfiguration> = this.defaultConfig;

    get config(): Partial<DsDatepickerConfiguration> {
        return { ...this._config, showClearAll: !!this.value };
    }
}
